import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalKioskQuizComponent } from './portal.kiosk.quiz/portal.kiosk.quiz.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PageQuizComponent } from './page.quiz/page.quiz.component';
import { PortalKioskPrintComponent } from './portal.kiosk.print/portal.kiosk.print.component';
import { PortalKioskFinalComponent } from './portal.kiosk.final/portal.kiosk.final.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalKioskMainComponent } from './portal.kiosk.main/portal.kiosk.main.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageChatComponent } from './page.chat/page.chat.component';
import { PortalKioskFinishComponent } from './portal.kiosk.finish/portal.kiosk.finish.component';
import { PortalKioskChatComponent } from './portal.kiosk.chat/portal.kiosk.chat.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageMainComponent } from './page.main/page.main.component';
import { LayoutKioskComponent } from './layout.kiosk/layout.kiosk.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PortalKioskQuizComponent,
        PortalSeasonAlertComponent,
        PageQuizComponent,
        PortalKioskPrintComponent,
        PortalKioskFinalComponent,
        LayoutEmptyComponent,
        PortalKioskMainComponent,
        PortalSeasonFormDropdownComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalSeasonTreeComponent,
        PageChatComponent,
        PortalKioskFinishComponent,
        PortalKioskChatComponent,
        PortalSeasonModalComponent,
        PortalSeasonPaginationComponent,
        PageMainComponent,
        LayoutKioskComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        
    ],
    providers: [{
        provide: COMPOSITION_BUFFER_MODE,
        useValue: false
    }],
    bootstrap: [AppComponent]
})
export class AppModule { }